import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const QRCodeComponent = ({ phoneNumber, formattedPhoneNumber }) => {
  const qrValue = `tel:${phoneNumber}`;

  return (
    <div style={{ textAlign: 'center' }}>
      <h2>Scan to dial</h2>
      <QRCodeSVG value={qrValue} size={192} />
      <p>Scan this QR code to open your dialpad with the number {formattedPhoneNumber}.</p>
    </div>
  );
};

export default QRCodeComponent;
